import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import {
  DSButton,
  DSCardWrapper,
} from "@components/design-system/molecules";
import {
  faMicrophone,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";

import SleepyScribbles from "../../../assets/imgs/scribbles-sleep.svg";
import { useWatchUserWsEvent } from "../../../hooks";
import Loading from "../../common/loading/Loading";
import RecordingModal from "../../common/modals/RecordingModal";

export const GET_NOTE = gql`
  query getProcessingNote($uuid: String) {
    processingNote(uuid: $uuid) {
      uuid
      isMarkedAsProcessing
    }
  }
`;

export function ProcessingNoteFormFallback({ note }) {
  const [shouldShowRecordingModal, setShouldShowRecordingModal] =
    useState(false);

  const queryOptions = {
    uuid: note?.uuid,
  };

  const { data, refetch } = useQuery(GET_NOTE, {
    variables: queryOptions,
    fetchPolicy: "no-cache",
  });

  useWatchUserWsEvent({
    onMessage: () => refetch(queryOptions),
    eventName: "note_update",
  });

  // POTENTIAL RACE CONDITION: Click immediately after finishing a recording
  // POTENTIAL SOLUTION: don't let them click from the inbox for at least 10 seconds
  // Or, tell them not to check so soon
  const isRefreshCheckAllowed =
    data?.processingNote?.isMarkedAsProcessing == false;

  return (
    <>
      <RecordingModal
        shouldShow={shouldShowRecordingModal}
        setShouldShow={setShouldShowRecordingModal}
        isForEditNote={true}
        noteUuid={note?.uuid}
      />
      <DSCardWrapper variant="ghost" padding="p-xl">
        <div className="flex flex-col items-center text-center justify-center gap-md">
          {isRefreshCheckAllowed ? (
            <>
              <img
                className="flex self-center"
                width="200px"
                src={SleepyScribbles}
              />
              <h4>All done!</h4>

              <h5 className="max-w-3xl">
                Your automatic note is ready for review. Please reload
                the page to see it.
              </h5>
              <DSButton
                type="button"
                icon={faSync}
                onClick={() => {
                  window.location.reload();
                }}
              >
                Reload
              </DSButton>
            </>
          ) : (
            <>
              <Loading shouldShow />

              <h4>Hang tight!</h4>

              <h5 className="max-w-3xl">
                Your automatic note is currently being written by our
                magic scribe fairies. You may still add to the
                recording, and we'll include the additional
                information.
              </h5>
              <DSButton
                onClick={() => setShouldShowRecordingModal(true)}
                dataTestId="add-to-recording-button"
                icon={faMicrophone}
              >
                Add to Recording
              </DSButton>
            </>
          )}
        </div>
      </DSCardWrapper>
    </>
  );
}
